import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import translate from "@insite/client-framework/Translate";
import { AvailabilityMessageType, ProductModel } from "@insite/client-framework/Types/ApiModels";

/**
 *
 * @param length Max length 10
 * @returns string
 */
export const utilsRandom = (length?: number) => {
    const newLength = length || 5;

    return Math.random().toString(36).substr(2, newLength).toString();
};

/**
 * This function gets the unitOfMeasureDisplay or unitOfMeasure of the first array of Units of measure
 * If there is no a UOM the default value is translate("Unit")
 * @param product ProductModel
 * @returns
 */
export const getCurrentUom = (product: ProductModel) => {
    const defaultUomText = translate("Unit");
    let returnUom: string = defaultUomText;

    if (product.unitOfMeasures && product.unitOfMeasures[0]) {
        const { unitOfMeasureDisplay, unitOfMeasure } = product.unitOfMeasures[0];
        const getUom = unitOfMeasureDisplay || unitOfMeasure || null;
        returnUom = getUom || returnUom;
    }

    return returnUom;
};

/**
 * This function gets needed info from the ProductInfo object.
 * @param productInfo
 * @returns
 */
export const getInfo = (productInfo: ProductInfo) => {
    const outOfStock =
        productInfo.inventory == null ||
        productInfo.inventory?.inventoryAvailabilityDtos == null ||
        productInfo.inventory.inventoryAvailabilityDtos?.length === 0
            ? true
            : productInfo.inventory.inventoryAvailabilityDtos[0].availability == null ||
              productInfo.inventory.inventoryAvailabilityDtos[0].availability?.messageType ===
                  AvailabilityMessageType.OutOfStock;

    const qtyOnHand = productInfo.inventory != null ? productInfo.inventory.qtyOnHand : 0;
    const unitOfMeasure = productInfo.unitOfMeasure;
    const additionalResults =
        productInfo.pricing != null ? productInfo.pricing.additionalResults : { futureAvailability: "[]" };
    const futureAvailability = JSON.parse(additionalResults ? additionalResults["futureAvailability"] : "[]");
    const qtyOnOrder = additionalResults && additionalResults["qtyOnOrder"] ? additionalResults["qtyOnOrder"] : "";
    return {
        outOfStock,
        qtyOnHand,
        unitOfMeasure,
        futureAvailability,
        qtyOnOrder,
    };
};
